import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Tag,
  title: 'Tag',
  category: ComponentCategory.General,
};
